<div class="flex flex-col space-y-4 pb-8">
  <!-- Default Company Notification -->
  <div
    *ngIf="hasDefaultCompany$ | async"
    class="bg-blue-50 border border-blue-200 rounded-md p-4"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-2">
        <span class="material-icons-outlined text-blue-600 text-sm">info</span>
        <span class="text-sm text-blue-800">
          You have a default company set. You'll be automatically redirected
          when visiting the companies page.
        </span>
      </div>
      <button
        mat-button
        class="text-blue-600 hover:bg-blue-100"
        (click)="clearDefaultCompany()"
      >
        <span class="lg:hidden"> Clear </span>
        <span class="hidden lg:block"> Clear Default </span>
      </button>
    </div>
  </div>

  <div class="company-list-header-bar">
    <div class="header-first-row">
      <div class="header-title">Companies</div>
      <button tix-button>
        <tix-icon svgIcon="plus-solid" routerLink="add"></tix-icon>
        <span
          class="add-button-text ml-1"
          routerLink="add"
          (click)="onAddCompany()"
          >Add Company</span
        >
      </button>
    </div>
    <div class="header-second-row">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input
          matInput
          type="text"
          placeholder="Search for companies"
          (keyup)="handleInputChange($any($event).target.value)"
        />
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="loaded$ | async; else loadingState">
    <ng-container *ngIf="companies$ | async as companies">
      <div
        class="company-card-list grid grid-cols-1 md:grid-cols-2 gap-4"
        *ngIf="companies.length > 0; else noData"
      >
        <tix-company-card
          *ngFor="let company of companies"
          [company]="$any(company)"
        ></tix-company-card>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noData>
    <div
      class="bg-white flex-1 flex flex-col shadow-sm items-center justify-center space-y-2 rounded-md border border-gray-200 p-10"
    >
      <span class="material-icons-outlined text-primary text-5xl"
        >inventory_2</span
      >
      <span class="text-md font-semibold text-primary">No Companies Found</span>
    </div>
  </ng-template>

  <ng-template #loadingState>
    <tix-loading-state
      [isLoading]="true"
      [hasError]="false"
      type="inline"
      loadingText="Loading Companies"
      loadingSubText="Fetching your companies..."
    ></tix-loading-state>
  </ng-template>
</div>
